import { useMemo } from 'react';
import { FORM_TYPE } from 'src/constants';
import { RootState, useAppSelector } from 'src/redux/store';
import { TargetOrganization } from '../hooks/useChangeRespondentModal';

export const useSeriesSbuName = () => {
  const enqueteData = useAppSelector((state: RootState) => state.enqueteCreate.enqueteData);
  const formType = enqueteData.surveyDetail?.surveyHeader?.formType;

  return useMemo(() => {
    const transformSbuNameWithCode = (org: TargetOrganization) => {
      const transformedOrg = { ...org };
      if (!org || !org.sbuName) return org;
      if (formType === FORM_TYPE.SERIES && !transformedOrg.sbuName?.includes(`(${transformedOrg.sbuCode})`)) {
        transformedOrg.sbuName = `${org.sbuName}(${org.sbuCode})`;
      }
      return transformedOrg;
    };
    return { transformSbuNameWithCode };
  }, [formType]);
};
